/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuthenticateModel { 
    emailAddress?: string | null;
    phoneNumber?: string | null;
    countryCode?: string | null;
    password?: string | null;
    isMobileRequest?: boolean;
    deviceId?: string | null;
    tenantId?: number | null;
    isSwaggerLogin?: boolean;
    rememberMe?: boolean;
}

